/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import LocalizationComponent from '../Localization/LocalizationComponent';
import UserMessageManager from '../Playbar/UserMessageManager';
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import Effect from './Effect';

/** @hidden */
const property: typeof cc._decorator.property = cc._decorator.property;

@cc._decorator.ccclass
export default class UserMessageEffect extends Effect
{
    @property({ override: true , type: InjectableComponent })
    protected reference: InjectableComponent<UserMessageManager> = new InjectableComponent();

    @property
    protected message: string = '';

    @property
    protected isLocalized: boolean = false;

    @property({ type: InjectableComponent, visible: (function(): boolean { return this.isLocalized; }) })
    protected localRef: InjectableComponent<LocalizationComponent> = new InjectableComponent();

    @property
    protected upperCase: boolean = false;

    private _setValue: string = '';

    /** @hidden */
    protected setContexts(): void
    {
        super.setContexts();
        this.reference.SetContext(UserMessageManager);
        this.localRef.SetContext(LocalizationComponent);
    }

    /** @hidden */
    protected start(): void
    {
        super.start();

        this.setValueFromLocalization();

        this.localRef.WithValue(local =>
            {
                local.OnChanged(() => this.setValueFromLocalization());
            });
    }

    /** @hidden */
    protected trigger = (): void =>
    {
        this.reference.WithValue(userMessageManager =>
            {
                userMessageManager.GetViewBuilder().AddText(this._setValue).Build();
            });
        this.complete();
    }

    private setValueFromLocalization(): void
    {
        this._setValue = this.localRef.WithValue(local => local.GetStringResource(this.message) || this.message,
            this.message);

        if (this._setValue && this.upperCase) { this._setValue = this._setValue.toUpperCase(); }
    }
}
